import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { UserManagementStore } from './user-management.store';
import { IUserManagementStore } from 'sustainment-component';

@Injectable({ providedIn: 'root' })
export class UserManagementQuery extends Query<IUserManagementStore> {
  public constructor(protected store: UserManagementStore) {
    super(store);
  }
}
